module.exports = __webpack_public_path__ + "img/video-image.bd4953c2.png";